function Gallery() {
    // Store image filenames in an array
    const photos = Array.from({ length: 48 }, (_, i) => `photo${26 + i}.jpeg`);

    return (
      <div style={{ textAlign: 'center', padding: '40px', background:'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)' }}>
        <h1 style={{ color: 'white', fontSize: '48px',fontFamily: 'Dancing Script, cursive' }}>Photo Gallery</h1>
        <p style={{ color: 'white', fontSize: '30px', fontStyle: 'italic', fontFamily: 'Dancing Script, cursive' }}>
          Some of our favorite photos 💖
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: '20px',
          justifyItems: 'center',
          paddingTop: '20px'
        }}>
          {photos.map((photo, index) => (
            <div key={index} style={{
              width: '200px',
              height: 'auto',
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
              overflow: 'hidden',
              transition: 'transform 0.3s ease, box-shadow 0.3s ease'
            }}>
              <img
                src={photo}
                alt={`Us ${index + 26}`}
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  transition: 'transform 0.3s ease',
                  borderRadius: '10px',
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  export default Gallery;
